import React from 'react';
function scrollToForm() {
  document.getElementById('lead-form')?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function StickyMobileCta() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-blue-100 bg-white/95 px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] backdrop-blur lg:hidden" data-id="element-97">
      <button type="button" onClick={scrollToForm} className="w-full rounded-xl bg-blue-600 px-6 py-3.5 text-lg font-semibold text-white transition hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2" data-id="element-98">
        Записаться на консультацию
      </button>
    </div>;
}